import React from 'react'

const Pin = () => {
  return (
    <svg
      height="20"
      width="20"
      fill="none"
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.81311 1.54657C5.68174 2.67794 5.51675 4.96425 5.3989 5.78921L2.36337 5.99631C3.06376 8.77154 5.24681 10.9456 8.02022 11.6532L8.22733 8.61763C9.05229 8.49978 11.3386 8.33479 12.47 7.20342C14.9975 4.67591 9.34062 -0.98094 6.81311 1.54657Z"
        fill="#f1f5f9"
        stroke="#e2793c"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.40332 9.61328L0.802721 13.2139"
        stroke="#e2793c"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Pin
